<template>
  <el-dialog
    title="选择流程"
    :visible.sync="dialogVisible"
    width="1000px">
    <div>
      <div style="margin-bottom: 40px;">
        <el-row :gutter="24">
          <el-col :span="6">
            <div style="display: flex;">
              <el-input v-model="where.flow_title" size="mini" placeholder="请输入流程标题"></el-input>
            </div>
          </el-col>
          <el-col :span="6">
            <div style="display: flex;">
              <el-input v-model="where.serial_number" size="mini" placeholder="请输入流程编号"></el-input>
            </div>
          </el-col>
          <el-col :span="6">
            <div style="display: flex;">
              <el-input v-model="where.user_name" size="mini" placeholder="请输入发起人"></el-input>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="24" style="margin-top: 10px">
          <el-col :span="10">
            <div style="display: flex;">
              <span style="white-space: nowrap;display: flex;align-items: center;">发起日期：</span>
              <el-date-picker
                v-model="where.date_range"
                size="mini"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd">
              </el-date-picker>
            </div>
          </el-col>
          <el-col :span="6">
            <div style="display: flex;">
              <el-select v-model="where.type" placeholder="请选择" size="mini">
                <el-option label="我发起的" value="self"></el-option>
                <el-option label="我经办的" value="handled"></el-option>
              </el-select>
            </div>
          </el-col>
          <el-col :span="1">
            <div>
              <el-button size="mini" type="primary text2" @click="searchs">搜索</el-button>
            </div>
          </el-col>
        </el-row>
      </div>
      <div>
        <el-table
          :data="pageData.list"
          :default-sort = "{}"
          border
          @selection-change="handleSelectionChange"
          style="width: 100%">
          <el-table-column type="selection" width="40"></el-table-column>
          <el-table-column prop="process_name" label="标题"></el-table-column>
          <el-table-column prop="serial_number" label="流水号" width="200"></el-table-column>
          <el-table-column label="状态" width="80">
            <template slot-scope="scope">
              <template v-if="scope.row.flow_status > 0">
                <el-tag v-if="scope.row.flow_status == 9" type="danger">已拒绝</el-tag>
                <el-tag v-if="scope.row.flow_status == 10" type="danger">撤销</el-tag>
                <el-tag v-if="scope.row.flow_status == 11" type="danger">重填</el-tag>
              </template>
              <template v-else>
                <el-tag v-if="scope.row.is_finish && scope.row.flow_status != 9" type="success">已结束</el-tag>
                <el-tag v-if="!scope.row.is_finish">在处理</el-tag>
              </template>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="pagination-wrap">
        <el-pagination background layout="prev, pager, next" :total="pageData.total*1" :page-size="pageData.pageSize*1" :current-page="pageData.page*1" @current-change="pageChange"></el-pagination>
      </div>
    </div>
    <div class="personnel-footer">
      <el-button size="mini" type="info" @click="closeFun">取 消</el-button>
      <el-button size="mini" type="primary" @click="confirmFun">确 定</el-button>
    </div>
  </el-dialog>

</template>

<script>
import Http from "../common/Http";
export default {
  name: "SelectFlow",
  data(){
    return {
      dialogVisible:false,
      loading:false,
      where:{
        "fps.user_id":0,
        "fps.business_type":1,
        "urgency_level":"",
        "flow_title":"",
        "flow_name":"",
        "date_range":"",
        "user_name":"",
        "serial_number":"",
        "master_id":"",
        "department_id":"",
        "department_name":"",
        "ancestor_name":"",
        "type": 'self',
      },
      pageData:{
        list:[],
        page:1,
        total:0,
        pageSize:10
      },
      callback_fun:undefined,
    }
  },
  mounted() {
    // this.getUserRoleList()
  },
  methods:{
    initConfig(){
      this.where = {
        "fps.user_id":0,
        "fps.business_type":1,
        "urgency_level":"",
        "flow_title":"",
        "flow_name":"",
        "date_range":"",
        "user_name":"",
        "serial_number":"",
        "master_id":"",
        "department_id":"",
        "department_name":"",
        "ancestor_name":"",
        "type": 'self',
      }
      this.pageData = {
        list:[],
        page:1,
        total:0,
        pageSize:10
      };
      this.callback_fun=undefined;
      this.selectData = [];
    },
    /**
     * 显示流程
     */
    show({},callback_fun){
      const that = this;
      that.initConfig();

      that.dialogVisible=true;
      if(typeof callback_fun === "function"){
        that.callback_fun = callback_fun;
      }
      that.getList();
    },
    confirmFun(){
      if(typeof this.callback_fun === "function"){
        this.callback_fun(this.selectData);
        this.callback_fun = undefined;
      }
      this.dialogVisible=false;
    },
    closeFun(){
      if(typeof this.callback_fun ==="function"){
        this.callback_fun=undefined;
      }
      this.dialogVisible=false;
    },
    // getList() {
    //   const that = this;
    //   that.loading=true;
    //   let where = that.where;
    //   Http.get("flow/FlowProcessSteps/selectProcessStepList",where,res=>{
    //     if(res.code) {
    //       that.pageData=res.data
    //     }
    //     that.loading=false;
    //   })
    // },
    getList() {
      const that = this;
      that.loading=true;
      that.where['fps.user_id'] = 0
      that.where['fps.business_type'] = 1
      Http.get("flow/FlowProcessSteps/getProcessStepsList",{
        where:that.where,
        field:"task.serial_number,task.sheet_id,task.process_name,task.user_id,task.task_id,task.master_id,task.is_finish,task.urgency_level,fps.id,fps.select_action,fps.node_id,fps.posted_time,fps.handle_time,fps.receive_time,fps.finish_time",
        page: this.pageData.page,
        page_size: this.pageData.pageSize,
        type: that.where.type
      },res=>{
        if(res.code) {
          that.pageData=res.data
        }
        that.loading=false;
      })
    },
    searchs() {
      this.pageData.page = 1
      this.getList()
    },
    pageChange(i) {
      this.pageData.page = i;
      this.where.page = i;
      this.getList();
    },
    handleSelectionChange(val) {
      this.selectData = val
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../common";
.personnel-footer{
  margin-top: 10px;
  width: 100%;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Flow/components/SelectFlow.vue